import { createSlice } from "@reduxjs/toolkit";

// This slice holds fetched API data only for the Brands module
// (operations/brands). It is deliberately not a copy of
// brandConfigurationReportSlice's UI state — screen-level state (filters,
// sort, pagination, search) lives in each owning component's own useState,
// synced via useSearchParams. The Run Process wizard reused on this page
// continues to read/write brandConfigurationReportSlice directly, since that
// is the slice RunBrandData.tsx already targets.
interface BrandsState {
  allBrandsData: any[];
  brandsMetadata: Record<string, any>;
  isFetchedBrandsData: boolean;
  isLoadingBrandsData: boolean;
  // Brands-owned equivalents of brandConfigurationReportSlice's Edit
  // Properties / Validation Station fields — populated by the Brands-owned
  // useBrandProperties.ts hook and ValidationStatusDialog.tsx, not the
  // legacy module's.
  brandPropertiesData: any[];
  brandBackendRequirementsData: any[];
  brandPropertiesLoader: boolean;
  testAgainPopupData: any[];
  testAgainPopupMetadata: Record<string, any>;
  isFetchedPopupData: boolean;
}

const initialState: BrandsState = {
  allBrandsData: [],
  brandsMetadata: {},
  isFetchedBrandsData: false,
  isLoadingBrandsData: false,
  brandPropertiesData: [],
  brandBackendRequirementsData: [],
  brandPropertiesLoader: false,
  testAgainPopupData: [],
  testAgainPopupMetadata: {},
  isFetchedPopupData: false,
};

const brandsSlice = createSlice({
  name: "brands",
  initialState,
  reducers: {
    setAllBrandsData: (state, action) => {
      state.allBrandsData = action.payload;
    },
    setBrandsMetadata: (state, action) => {
      state.brandsMetadata = action.payload;
    },
    setIsFetchedBrandsData: (state, action) => {
      state.isFetchedBrandsData = action.payload;
    },
    setIsLoadingBrandsData: (state, action) => {
      state.isLoadingBrandsData = action.payload;
    },
    setBrandPropertiesData: (state, action) => {
      state.brandPropertiesData = action.payload;
    },
    setBrandBackendRequirementsData: (state, action) => {
      state.brandBackendRequirementsData = action.payload;
    },
    setBrandPropertiesLoader: (state, action) => {
      state.brandPropertiesLoader = action.payload;
    },
    setTestAgainPopupData: (state, action) => {
      state.testAgainPopupData = action.payload;
    },
    setTestAgainPopupMetadata: (state, action) => {
      state.testAgainPopupMetadata = action.payload;
    },
    setIsFetchedPopupData: (state, action) => {
      state.isFetchedPopupData = action.payload;
    },
    resetBrandsData: () => initialState,
  },
});

export const {
  setAllBrandsData,
  setBrandsMetadata,
  setIsFetchedBrandsData,
  setIsLoadingBrandsData,
  setBrandPropertiesData,
  setBrandBackendRequirementsData,
  setBrandPropertiesLoader,
  setTestAgainPopupData,
  setTestAgainPopupMetadata,
  setIsFetchedPopupData,
  resetBrandsData,
} = brandsSlice.actions;
export default brandsSlice.reducer;
